module.exports = __webpack_public_path__ + "img/trait.6602dee0.png";